export const COMPANY_NAME = 'FEVERDREAM';
export const COMPANY_ADDRESS_FULL = '469 LITERARY ROAD SUITE 2, CLEVELAND, OH 44113-4511';
export const COMPANY_ADDRESS_SHORT = '469 LITERARY ROAD SUITE 2';
export const COMPANY_CITY = 'CLEVELAND';
export const COMPANY_STATE = 'OH';
export const COMPANY_ZIP = '44113-4511';
export const COMPANY_LOCATION = 'CLEVELAND, OH';
export const MAP_URL = 'https://www.google.com/maps/search/?api=1&query=469+LITERARY+ROAD+SUITE+2%2C+CLEVELAND%2C+OH+44113-4511';

export const SOURCE_LABEL = 'FEVERDREAM source record';
export const HERO_TAGLINE = 'Company profile details from the provided FEVERDREAM file.';
export const PROFILE_SUMMARY = 'This page mirrors the public-safe FEVERDREAM source details: company name and company address.';

export const IDENTITY_CARDS = [
  { label: 'Company', value: COMPANY_NAME },
  { label: 'City / State', value: COMPANY_LOCATION },
  { label: 'Company Address', value: COMPANY_ADDRESS_FULL },
];

export const PROFILE_POINTS = [
  `Company name: ${COMPANY_NAME}`,
  `Company Address: ${COMPANY_ADDRESS_FULL}`,
];
